<template>
    <div>
        <!-- 司机-优享券-发放 -->

        <el-drawer title="发放优享券" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px" destroy-on-close>
            <!-- 基本信息表单 -->
            <div class="form-box priority">
                <template>
                    <el-form ref="form" :model="submit_data" label-width="130px" style="height: 90vh; overflow-y: auto">
                        <el-form-item label="发放方式:">
                            <el-radio-group v-model="sendStyle">
                                <el-radio label="1">普通发放</el-radio>
                                <el-radio label="2">批量发放</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <div v-if="sendStyle == '1'">
                            <el-form-item label="发放数量:">
                                <el-input
                                    v-model="submit_data.num"
                                    :placeholder="submit_rules.num.placeholder"
                                    style="width: 150px; margin-right: 5px"
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="司机手机号:">
                                <el-input
                                    v-model="submit_data.driver_phone"
                                    :placeholder="submit_rules.driver_phone.placeholder"
                                    style="width: 150px; margin-right: 5px"
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="备注:">
                                <el-input
                                    v-model="submit_data.remark"
                                    :placeholder="submit_rules.remark.placeholder"
                                    style="width: 150px; margin-right: 5px"
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="姓名:">
                                <el-input v-model="name" placeholder="请输入姓名" style="width: 150px; margin-right: 5px"> </el-input>
                                <el-button type="primary" @click="driverLists(name)">搜索</el-button>
                            </el-form-item>
                            <el-form-item label="关联手机号:">
                                <el-radio-group v-model="driver_phone" @change="phoneChange(driver_phone)">
                                    <el-radio v-for="(value, key) in phoneArray" :label="value" :key="key" border>
                                        {{ value.phone }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div v-if="sendStyle == '2'">
                            <el-form-item>
                                <div>
                                    <el-button type="primary" style="margin-bottom: 10px" @click="download1">下载模板</el-button>
                                    <div style="color: red; font-size: 12px">
                                        注：下载的csv表格文件，第一列为手机号，第二列为优享券数量，第三列为备注<br />注：发放数量要小于等于添加优享券时填写的数量
                                    </div>

                                    <el-upload
                                        style="width: 350px; height: 200px; line-height: 20px"
                                        class="upload-demo"
                                        drag
                                        accept=".csv"
                                        :action="text_upload_url"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="text_headers"
                                        :data="submit_data_send"
                                        :on-success="getExcelData"
                                        multiple
                                    >
                                        <div class="el-upload__text upload">将文件拖到此处，或<em>点击上传</em></div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                    <!-- 对话框底部按钮 -->
                    <div v-if="sendStyle == '1'" style="display: flex; justify-content: center">
                        <submitBtn
                            @onSubmitDig="onSubmitDig"
                            :data="submit_data"
                            :rules="submit_rules"
                            :url="submit_url"
                            :JSON_Boolean="true"
                            @toJSON="toJSON"
                        ></submitBtn>
                        <el-button @click="closeDialog">关闭</el-button>
                    </div>
                </template>
            </div>
        </el-drawer>
    </div>
</template>

<script>
var _this;
import { config } from '@/utils/config'; // 配置
//终端安装插件 npm install --save csv-exportor
// import {exportCsv} from '@/utils/utils.js';
import CsvExportor from 'csv-exportor'; //引入安装的插件

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.submit_data.priority_mode_code = _this.data;
            _this.submit_data_send.priority_mode_code = _this.data;
        }
    },
    data() {
        return {
            name: '',
            driver_phone: '',
            phoneArray: [],
            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                sex: '',
                status: '',
                real_name: '',
                id_card: '',
                insurance_alarm: '',
                fixed_array: '',
                signing_type: '',
                insurance_status: ''
            },
            downFileData: [{ phone: '13454565434', num: '2', remark: '8月份推广加优享券' }], //csv 文件数据

            text_upload_url: config.axios_baseURL + '/priority/sendPriorityBatch',
            // 上传文件的请求头
            text_headers: {
                'city-tag': '',
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'service-tag':''
            },
            sendStyle: '1',

            excelData: [],

            priority_mode_code: '',

            show: false,

            submit_url: '/priority/sendPriority',
            // 表单数据

            submit_data: {
                num: '',
                driver_phone: '',
                priority_mode_code: '',
                operation: 'priority_coupon',
                mode: 'add',
                remark: ''
            },
            submit_data_send: {
                // priority_mode_code: '',
                // operation: 'priority_coupon',
                // mode: 'add'
            },

            submit_rules: {
                driver_phone: {
                    placeholder: '司机电话',
                    rules: {
                        required: true,
                        message: '司机电话不正确',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                num: {
                    placeholder: '发放数量',
                    rules: {
                        required: true,
                        message: '发放数量不正确',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                remark: {
                    placeholder: '备注',
                    rules: {
                        required: false,
                        message: '备注不正确',
                        regulation: 'between_str',
                        rulesData: [1, 50]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 关联手机号change方法
        phoneChange(val) {
            _this.submit_data.driver_phone = val.phone;

        },
        // 输入姓名后搜索司机列表
        driverLists(name) {

            if (name == '') {
                this.$message.error('请输入司机姓名再搜索！');

                return;
            }

            _this.search_data.name = name;
            _this
                .$post('/driver/driverLists', _this.search_data)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.phoneArray = res.data;
                    if(res.data.length==0){
                        this.$message.error('暂无数据');

                    }

                })
                .catch((err) => {});
        },
        // 下载模板方法
        download1() {
            let tableData = _this.downFileData;

            let header = ['13345678765', '1', '7月份上线推广奖励优享券'];
            CsvExportor.downloadCsv(tableData, { header }, '批量上传优享券模板.csv');
        },

        beforeAvatarUpload(file) {

            // 添加请求头
            _this.text_headers['city-tag'] = localStorage.getItem('city_tag');
            _this.text_headers['service-tag'] = localStorage.getItem('service_tag');
            _this.text_headers.token = localStorage.getItem('access_token');
            _this.text_headers['hash-key'] = _this.$hash_key();
            
        },

        getExcelData(response) {
            if (response.data.length == 0) {
                this.$message.success('批量操作全部成功！');
                _this.$emit('onSubmit');
                _this.closeDialog();
                return;
            }
            this.$message.error('符合条件数据已导入，异常数据见excel表格！');

            if (this.$route.path == '/priority') {
                // 导出excel的空数组中添加数据
                for (let i = 0; i < response.data.length; i++) {
                    // 向excelData数组里添加
                    _this.excelData.push({
                        phone: response.data[i][0],
                        num: response.data[i][1],
                        remark: response.data[i][2],
                        why: response.data[i][3]
                    });
                }

                // 将数据导出excel
                _this.exportData();

                // 清空数据
                _this.excelData = [];
            }
        },
        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['电话号', '数值', '备注', '失败原因'];
            const filterVal = ['phone', 'num', 'remark', 'why'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '导入失败数据');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.name = '';
            _this.driver_phone = '';
            _this.phoneArray = [];
            //翻页数据
            _this.search_data = {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                sex: '',
                status: '',
                real_name: '',
                id_card: '',
                insurance_alarm: '',
                fixed_array: '',
                signing_type: '',
                insurance_status: ''
            };
            _this.submit_data = {
                num: '',
                driver_phone: '',
                priority_mode_code: '',
                operation: 'priority_coupon',
                mode: 'add',
                remark: ''
            };
            _this.submit_data_send = {
                // priority_mode_code: '',
                // operation: 'priority_coupon',
                // mode: 'add'
            };
        },
        // 数据整理
        toJSON() {
            if (_this.sendStyle == '1') {
                // 如果是普通发放 司机手机号和发放数量是必填项

                _this.submit_rules.driver_phone.rules.required = true;

                _this.submit_rules.num.rules.required = true;
            } else {
                _this.submit_rules.driver_phone.rules.required = false;

                _this.submit_rules.num.rules.required = false;
            }
        },
        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
<style>
.priority .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
    margin-top: 10px;
}
</style>
